import { createSelector } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { BaseAsyncValue } from '../../../../shared/models/async-value';
import { SpecFieldNames } from '../../specification/constants/specification-field-names.enum';
import { AddedValueFieldConfig } from '../models/form-added-value-field-config';
import { getRmsRehydrate } from '../selectors';
import { getAvailableAddedValues } from '../selectors/added-value.selectors';

const addedValueAndRehydrate = createSelector(getAvailableAddedValues, getRmsRehydrate, (availables, rehydate) => {
  return {
    availables,
    rehydate,
  };
});

export namespace AddedValueDisabler {
  export class IsLoading extends BaseAsyncValue<Boolean> {
    getValue(): Observable<Boolean> {
      return this.store.select(addedValueAndRehydrate).pipe(
        takeUntil(this.ngDestroy),
        map(({ availables }) => {
          const productCode = this.form.get(SpecFieldNames.PRODUCT_SELECTION).value;
          return availables[productCode];
        }),
        map(state => {
          if (state) {
            const index = (this.config as AddedValueFieldConfig).index;
            if (state[index]) {
              if (state[index].addedValues === null) {
                return true;
              } else {
                if (state[index].loading === false) {
                  // If there are 0 added values, then disable (return true)
                  if (state[index].addedValues.length) {
                    return false;
                  } else {
                    return true;
                  }
                  // End if for added values length checking
                } else {
                  return true;
                }
              }
            } else {
              return true;
            }
          } else {
            return true;
          }
        }),
      );
    }
  }
}
